// extracted by mini-css-extract-plugin
module.exports = {"container":"Transition_container__1cJv2","containerPanel":"Transition_containerPanel__L01Bv","transition":"Transition_transition__2CSzI"};